import { render, staticRenderFns } from "./AddPatientSurgeryInfo.vue?vue&type=template&id=ae5cce02&scoped=true"
import script from "./AddPatientSurgeryInfo.vue?vue&type=script&lang=js"
export * from "./AddPatientSurgeryInfo.vue?vue&type=script&lang=js"
import style0 from "./AddPatientSurgeryInfo.vue?vue&type=style&index=0&id=ae5cce02&prod&scoped=true&lang=css"
import style1 from "./AddPatientSurgeryInfo.vue?vue&type=style&index=1&id=ae5cce02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5cce02",
  null
  
)

export default component.exports